import { constantRoutes } from '@/router'
import menuRoutes from '@/router/menu'
import fmMenuRoutes from '@/router/fmMenu'
const permission = {
  state: {
    routes: [],
    addRoutes: [],
    menus: [],
    annualInfo: {}
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_ANNUALINFO: (state, data) => {
      state.annualInfo = data
    }
  },
  actions: {
    GenerateRoutes({ commit, state }, role) {
      return new Promise(resolve => {
        if (role === 1 || role === 2 || role === 3) {
          filterMenuRoute(fmMenuRoutes, role, false)
          fmMenuRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', fmMenuRoutes)
          resolve(fmMenuRoutes)
        } else if (+role === 0) {
          const isAnnualNav = true
          filterMenuRoute(menuRoutes, role, isAnnualNav)
          menuRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', menuRoutes)
          resolve(menuRoutes)
        }
      })
    }
  }
}
function filterMenuRoute(menu, role, isAnnualNav) {
  return menu.filter(i => {
    if (!i.children) {
      if (i.roles && i.roles.indexOf(role) > -1) {
        if (
          role === 0 &&
          isAnnualNav &&
          i.path === '/wellManagement/annualReview'
        ) {
          i.hidden = false
          return i
        }
        return i
      }
    } else if (i.children.length) {
      i.children = filterMenuRoute(i.children, role, isAnnualNav)
    }
  })
}

export const loadView = view => {
  // return () => import(`@/views/${view}`);
  return () => Promise.resolve(require(`@/views/${view}`).default)
}

export default permission
